<template>
  <div class="social-media" v-show="activeShareMedia">
    <button class="close-social-media" @click="close">
      <i class="fa fa-times"></i>
    </button>
    <ul class="list-group list-group-horizontal-sm" v-if="full">
    </ul>
    <ul v-if="!full">
      <li class="list-inline" v-for="socialMedia in socialMedias" :key="socialMedia.type">
        <button class="btn btn-default" :data-type="socialMedia.type" @click="shareLink($event)">
          <i :class="socialMedia.icon" aria-hidden="true"></i>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import JSShare from "js-share"

export default {
  name: "SocialMedia",
  props:  {
    photo: {},
    full: false,
    activeShareMedia: false,
  },
  data() {
    return {
      socialMedias: [
        {type: 'fb', icon: 'fa fa-facebook'},
        {type: 'twitter', icon: 'fa-brands fa-x-twitter'},
        {type: 'pinterest', icon: 'fa fa-pinterest'},
        {type: 'whatsapp', icon: 'fa fa-whatsapp'},
      ]
    }
  },
  watch: {
    activeShareMedia(newVal, oldVal) {
      if(newVal) {
        if(navigator.canShare) {
          this.close();
          this.shareImage();
        }
      }
    }
  },
  methods: {
    async shareImage() {
      try {
        await navigator.share(await this.imageShareData);
      } catch (err) {
        console.log(`Error: ${err}`);
      }
    },
    shareLink(event) {
      this.close();
    },
    close() {
      this.$emit("closeSocialMedia");
    }
  },
  computed: {
    async imageShareData() {
      const response = await fetch(this.photo.original);
      const fileName = this.photo.filename;
      const blob = await response.blob();
      const images = [
        new File(
          [blob],
          fileName,
          {
              type: "image/jpeg",
              lastModified: new Date().getTime()
          }
        )
      ];
      return {files: images};
    }
  }
};
</script>

<style lang="scss" scoped>
  $color: gray;

  .social-media {
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.97);
    z-index: 9999;

    .close-social-media {
      cursor: pointer;
      position: absolute;
      right: 0;
      top: 5px;
      font-size: 21px;
      color: $color;
      width: 32px;
      height: 32px;
      z-index: 9999;
    }

    ul
      button {
        z-index: 999;
        cursor: pointer;
        i { z-index: 2; }
    }
  }

  #zoomPhotos {
    .social-media {
      top: 155px;
      height: 56px;
      left: 50px;
      background-color: transparent;

      .close-social-media {
        display: none;
      }
    }
  }
</style>
